// src/lib/assignmentRules.js

/**
 * Find the most specific matching assignment rule for a given category + severity.
 * Specificity: both match > category-only > severity-only > catch-all.
 * Returns the matched rule object or null.
 */
export function matchAssignmentRule(rules, category, severity) {
  if (!rules?.length) return null;
  let best = null, bestScore = -1;
  for (const rule of rules) {
    const catMatch = rule.category === "All" || rule.category === category;
    const sevMatch = rule.severity === "all" || rule.severity === severity;
    if (!catMatch || !sevMatch) continue;
    const score = (rule.category !== "All" ? 1 : 0) + (rule.severity !== "all" ? 1 : 0);
    if (score > bestScore) { best = rule; bestScore = score; }
  }
  return best;
}
